import React, { useReducer, Dispatch } from 'react';
import { SET_VALIDATION_START } from '../actions/users';
import { UsersValidation } from '../utils/types';

export interface UserAction {
  type: string;
  data: UsersValidation;
}

const initialState: UsersValidation = { validate: false };

const UsersStateContext = React.createContext(initialState);
const UsersDispatchContext = React.createContext<Dispatch<any> | undefined>(undefined);

const reducer = (state: UsersValidation, action: UserAction) => {
  const { type, data } = action;
  if (type === SET_VALIDATION_START) {
    return { ...state, ...data };
  } else {
    return state;
  }
};

const UsersProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <UsersStateContext.Provider value={state}>
      <UsersDispatchContext.Provider value={dispatch}>{children}</UsersDispatchContext.Provider>
    </UsersStateContext.Provider>
  );
};

const useUsersState = () => {
  const context = React.useContext(UsersStateContext);
  if (context === undefined) {
    throw new Error('useUsersState must be used within a <UsersProvider></UsersProvider>');
  }
  return context;
};

const useUsersDispatch = () => {
  const context = React.useContext(UsersDispatchContext);
  if (context === undefined) {
    throw new Error('useUsersDispatch must be used within a <UsersProvider></UsersProvider>');
  }
  return context;
};

export { UsersProvider, useUsersState, useUsersDispatch };
